<ul class="ms-field-view">
  <li class="field-label" [innerHTML]="label()"></li>
  <li>
    <pre
      class="field-value"
      [class]="fieldValueClass()"
      [msTooltip]="valueTooltip()"
      [options]="tooltipOptions()"
      [innerHTML]="value()"></pre>
  </li>
</ul>
